/**
 * @fileoverview Modelo de integración para usuarios de retailer en el inbox Mercately.
 * Gestiona operaciones CRUD y subrecursos relacionados con usuarios de retailer.
 * Implementa el patrón de modelo API con integración optimizada y manejo de CSRF.
 * @module RetailerUserModelMC
 * @category Model - API Layer
 * @since 2.0.0
 * @version 3.1.0
 */

import abstractModel from '../../../core/MercatelyModel';
import { MERCATELY_API_V2 } from '../../../constants/AppConstants';

// Recurso base para usuarios de retailer
const resource = `${MERCATELY_API_V2}/retailer_users`;

// Crear modelo abstracto con configuración base
const model = abstractModel(resource);

// Get retailer users all
model.getRetailerUsers = async (params) =>
  model.get(params, { path: `${resource}/inbox_agents` });

// Get active retailer users by role
model.getRetailerUsersByRole = async (params) =>
  model.get(params, { path: `${resource}/inbox_agents_by_role` });

export default model;